// @flow

export default class Collection<T> {
  #items: Array<T> = [];

  /**
   * Create a new Collection instance
   */
  constructor(items: Array<T>) {
    if (!items) return;
    this.#items = items;
  }

  /**
   * Get all items.
   */
  all(): Array<T> {
    return this.#items;
  }

  /**
   * Get the first item of the collection.
   */
  first(): T {
    return this.#items[0];
  }

  /**
   * Get an item according to a given callback.
   */
  find(callback: function): ?T {
    return this.#items.find((item: T) => callback(item));
  }

  /**
   * Reject one or multiple items from the collection
   */
  // eslint-disable-next-line no-use-before-define
  reject(callback: function): Collection<T> {
    return new Collection(this.#items.filter((item: T) => !callback(item)));
  }

  /**
   * Check if the collection contains the given item
   */
  contains(item: T): boolean {
    return this.#items.includes(item);
  }

  /**
   * Store one or multiple items to the collection.
   *
   * @param items
   */
  add(items: Array<T> | T): void {
    this.#items = this.#items.concat(items);
  }

  /**
   * Can delete a specific item from the collection.
   */
  delete(item: T): void {
    this.#items.splice(this.#items.indexOf(item), 1);
  }

  /**
   * Iterate over the items of the collection
   */
  each(callback: function): void {
    this.#items.forEach((item: T) => callback(item));
  }

  /**
   * Iterate over the items of the collection and map them
   */
  // eslint-disable-next-line no-use-before-define
  map(callback: function): Collection {
    return new Collection(this.#items.map((item: T) => callback(item)));
  }

  /**
   * Clear the collection.
   */
  clear(): void {
    this.#items = [];
  }

  /**
   * Count the items of the collection.
   */
  count(): number {
    return this.#items.length;
  }

  /**
   * Log the collection at that point
   * For test purposes
   */
  // eslint-disable-next-line no-use-before-define
  log(): Collection {
    console.log(this.all());
    return this;
  }
}
